import React, { Component } from 'react';
import SearchProductPage from './index'
import EditProduct from './edit'
import {EditProduct as EditProductAction} from "../../../actions/loading"
import { connect } from "react-redux";

import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

class ProductMain extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            activeTab: '1'
        }
    }
    toggle = tab => {
        if (this.state.activeTab !== tab)
            this.setState(prevState => ({
                ...prevState, activeTab: tab
            }));
    }
    render() {
        var proptab = [
             { Name: "Search", Id: "1" },
             { Name: "New", Id: "2" }
         ];
         var proptabitem = proptab.map((d) => <NavItem><NavLink
         className={classnames({ active: this.state.activeTab === d.Id })}
         onClick={() => {  this.toggle(d.Id); }}>
         {d.Name}
     </NavLink></NavItem>);
             return (
                <>
                <div style={{ marginLeft: "5%", marginRight: "5%" }} className="card pl-2 pt-2">
                <Nav pills >
                    {proptabitem}
                    </Nav>
                    <hr/>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                            {this.state.activeTab === '1' && <SearchProductPage />}
                        </TabPane>      
                        <TabPane tabId="2">
                            {this.state.activeTab === '2' && <EditProduct />}
                        </TabPane>      
                    </TabContent>
                </div>
                </>
             )
        }
}


var productMain = connect(
    state => ({
        UserData : state.UserData
    }),
    {EditProductAction}
)(ProductMain);

export default productMain
